// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  CONFIGURATION: 'CONFIGURATION',
  METADATA: 'METADATA',
  ORDER_OR_LOTS: 'ORDER_OR_LOTS',
  CLINS: 'CLINS',
  END_ITEMS: 'END_ITEMS',
  WBS: 'WBS',
  ACCOUNTS: 'ACCOUNTS',
  FUNCTIONAL_CATEGORIES: 'FUNCTIONAL_CATEGORIES',
  FUNCTIONAL_OVERHEAD_CATEGORIES: 'FUNCTIONAL_OVERHEAD_CATEGORIES',
  UNITS_OR_SUBLOTS: 'UNITS_OR_SUBLOTS',
  COST_HOUR_DEFINITIONS: 'COST_HOUR_DEFINITIONS',
  REPORTING_CALENDAR: 'REPORTING_CALENDAR',
  SUMMARY_COST_DATA: 'SUMMARY_COST_DATA',
  ACTUAL_COST_HOUR_DATA: 'ACTUAL_COST_HOUR_DATA',
  FORECAST_COST_HOUR_DATA: 'FORECAST_COST_HOUR_DATA',
  FORECAST_AT_COMPLETION_COST_HOUR: 'FORECAST_AT_COMPLETION_COST_HOUR',
  ORDER_OR_LOT_ALLOCATION_METHODS: 'ORDER_OR_LOT_ALLOCATION_METHODS',
  ORDER_OR_LOT_ALLOCATION_COMPONENTS: 'ORDER_OR_LOT_ALLOCATION_COMPONENTS',
  END_ITEM_ALLOCATION_METHODS: 'END_ITEM_ALLOCATION_METHODS',
  END_ITEM_ALLOCATION_COMPONENTS: 'END_ITEM_ALLOCATION_COMPONENTS',
  WBS_ALLOCATION_METHODS: 'WBS_ALLOCATION_METHODS',
  WBS_ALLOCATION_COMPONENTS: 'WBS_ALLOCATION_COMPONENTS',
  UNIT_OR_SUBLOT_ALLOCATION_METHODS: 'UNIT_OR_SUBLOT_ALLOCATION_METHODS',
  UNIT_OR_SUBLOT_ALLOCATION_COMPONENTS: 'UNIT_OR_SUBLOT_ALLOCATION_COMPONENTS',
  SUMMARY_REMARKS: 'SUMMARY_REMARKS',
  WBS_ELEMENT_REMARKS: 'WBS_ELEMENT_REMARKS',
  WBS_DICTIONARY_DEFINITIONS: 'WBS_DICTIONARY_DEFINITIONS',
  COST_HOUR_TAG_DEFINITIONS: 'COST_HOUR_TAG_DEFINTIONS'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts